import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import { get, post } from '../../Services/api';
import upload_image_firebase_storage from "../../Utility/upload_image_firebase_storage";
import { WaterTrackerUnits, convertWaterUnits } from '../../Utility/water_tracker_units';

import './profile_and_settings.css'
// import TextField from '@mui/material/TextField';
import { FormGroup, Checkbox, TextField, Radio, RadioGroup, InputLabel, MenuItem, Select, FormControlLabel, FormControl } from '@mui/material';
import InitialAvatar from "../../Components/InitialAvatar/InitialAvatar";
import yyyy_mm_dd_date_format from "../../Utility/yyyy_mm_dd_date_format";


function ProfileAndSettings() {
    const navigate = useNavigate();
    const { currentUser, userInfo } = useAuth();
    const [editingMode, setEditMode] = useState(false)
    const [allCuisines, setAllCuisines] = useState([])
    const [allCourses, setAllCourses] = useState([])
    const [configs, setConfigs] = useState(null)
    const [og_weight, setOgWeight] = useState(null)
    const [og_activity_level, setOgActivityLevel] = useState(null)
    const [all_info_copy, setAllInfoCopy] = useState(null)
    const [modifiedUserInfo, setModifiedUserInfo] = useState(userInfo);
    const [isReadyToPost, setIsReadyToPost] = useState(false); // New state for tracking readiness
    const [selectedPic, setSelectedPic] = useState(null); // New state for tracking readiness

    useEffect(() => {

        if (userInfo) {
            setModifiedUserInfo({ ...userInfo });
        }
    }, [userInfo]);

    useEffect(() => {
        constructor()
    }, [currentUser, modifiedUserInfo]);



    // useEffect to detect when the profile picture is updated and trigger the API call
    useEffect(() => {
        if (isReadyToPost) {
            (async () => {
                await post('/api/user-config/update-profile', { ...all_info_copy, today_date: yyyy_mm_dd_date_format({}) }); // Post only when the state has changed
                setIsReadyToPost(false); // Reset the flag
                setSelectedPic(null)
            })();
        }
    }, [isReadyToPost, all_info_copy]);

    function validateFields() {
        if (all_info_copy.first_name === '') {
            alert('Please enter your first name.');
            return false;
        } else if (all_info_copy.last_name === '') {
            alert('Please enter your last name.');
            return false;
        } else if (all_info_copy.height === '') {
            alert('Please provide your height.');
            return false;
        } else if (all_info_copy.weight === '') {
            alert('Please provide your weight.');
            return false;
        } else if (all_info_copy.planner_goal_fk.length === 0) {
            alert('Please select at least one meal planner goal.');
            return false;
        } else if (all_info_copy.fav_cuisines.length === 0) {
            alert('Please select at least one favorite cuisine.');
            return false;
        } else if (all_info_copy.courses.length === 0) {
            alert('Please select at least one course.');
            return false;
        } else if (all_info_copy.daily_water_goal === '') {
            alert('Please enter your daily water intake goal.');
            return false;
        }

        return true;
    }

    async function saveChanges() {
        if (validateFields() === true) {
            if (all_info_copy.profile_picture != userInfo.profile_picture) {
                const newImgUrl = await upload_image_firebase_storage({ path: '/User Images', imageFile: selectedPic })
                handleFieldChange('profile_picture', newImgUrl)
            }
            setIsReadyToPost(true);
        } else {
            setEditMode(true);
        }

    }

    const fileInputRef = useRef(null);

    // Function to handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            handleFieldChange('profile_picture', URL.createObjectURL(file))
            setSelectedPic(file)
        }
    };


    function populateAllInfo() {
        setAllInfoCopy({
            allCourses: allCourses,
            allCuisines: allCuisines,
            ...currentUser,
            configs: configs,
            ...modifiedUserInfo,
            weight: og_weight.weight,
            weight_unit: og_weight.unit
        })
    }

    async function constructor() {
        console.log('here')
        try {
            // All cuisines
            const result_cu = await get("/api/meal/get-all-cuisines")
            setAllCuisines(result_cu)
            // All cuisines
            const result_co = await get("/api/meal/get-all-meal-types")
            setAllCourses(result_co)

            const result_configs = await get("/api/user-config/get-questions-and-options")
            setConfigs(result_configs)

            const result_weight = await get("/api/user/get-last-user-entered-weight", { user_id: currentUser.uid })
            setOgWeight(result_weight)

            const result_activity_level = await get("/api/analytics/get-user-activity-level", { user_id: currentUser.uid })
            setOgActivityLevel(result_activity_level)

            setAllInfoCopy({
                allCourses: result_co,
                allCuisines: result_cu,
                configs: result_configs,
                ...currentUser,
                ...modifiedUserInfo,
                weight: Number(result_weight.weight),
                weight_unit: result_weight.unit,
                activity_level: result_activity_level.activity_level,
                tdee: result_activity_level.tdee
            })
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    function handleFieldChange(fieldName, newValue) {
        // Create a shallow copy of the object
        let updatedInfo = { ...all_info_copy };

        // Update the value of the specific field
        updatedInfo[fieldName] = newValue;

        // Set the state with the new object
        setAllInfoCopy(updatedInfo);
    }


    function handleWaterUnitFieldChange(newValue) {
        // Create a shallow copy of the object
        let updatedInfo = { ...all_info_copy };


        updatedInfo.daily_water_goal = convertWaterUnits(updatedInfo.daily_water_goal, updatedInfo['water_unit'], newValue)
        updatedInfo['water_unit'] = newValue;

        // Set the state with the new object
        setAllInfoCopy(updatedInfo);
    }

    function handleCheckboxChange(field, id, isChecked) {

        // Create a shallow copy of the existing array field
        let updatedField;
        if (field == 'activity_level') {
            updatedField = id;
        }
        else {
            if (isChecked) {
                // If checked, add the ID to the array
                updatedField = [...all_info_copy[field], id];
            } else {
                // If unchecked, remove the ID from the array
                updatedField = all_info_copy[field].filter((item) => item !== id);
            }
        }
        // Update the all_info_copy object with the updated array
        setAllInfoCopy({
            ...all_info_copy,
            [field]: updatedField,
        });
    }


    return (
        <div>

            {
                all_info_copy && all_info_copy.configs && all_info_copy.water_unit && all_info_copy.allCourses && all_info_copy.allCuisines && < div className="ps_parent_div">
                    <div className="ps_image_and_name">
                        <div className="ps_image_container" onClick={() => {
                            if (editingMode) {
                                fileInputRef.current.click(); // Trigger file input click
                            }
                        }}>
                            {
                                all_info_copy.profile_picture ? <img src={all_info_copy.profile_picture} className="ps_image" alt="Profile" />
                                    : <InitialAvatar />
                            }
                            {
                                editingMode && <div className={"ps_overlay font_family_inter font_size_24 green_3"}>
                                    Edit
                                </div>
                            }
                        </div>


                        <input
                            type="file"
                            ref={fileInputRef} // Reference to the input element
                            style={{ display: "none" }} // Hide the input element
                            onChange={handleFileChange} // Handle file selection
                            accept="image/*" // Optionally restrict to image files
                        />

                        <p className="font_weight_600 font_size_28">{userInfo.first_name + ' ' + userInfo.last_name}</p>

                        {
                            editingMode ? <div className="flex gap_10">
                                <div className="ps_action_profile_button" onClick={() => { setEditMode(false); saveChanges() }}>
                                    Save
                                </div>
                                <div className="ps_action_profile_button" onClick={() => { setEditMode(false); populateAllInfo() }}>
                                    Cancel
                                </div>
                            </div>
                                : <div className="ps_edit_profile_button" onClick={() => { setEditMode(true) }}>
                                    Edit Profile
                                </div>
                        }


                    </div>

                    <div className="ps_user_info">
                        <div className="ps_user_info_personal_info">
                            <p className="font_family_ovo font_size_24">
                                Personal Information
                            </p>
                            <div className="ps_user_info_personal_info_items">
                                <TextField label="First Name" value={all_info_copy['first_name']} variant="outlined"
                                    onChange={(e) => {
                                        handleFieldChange('first_name', e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: all_info_copy.first_name !== '', // Ensure label stays floated if there's a value
                                    }}
                                    disabled={!editingMode}
                                    required
                                />
                                <TextField label="Last Name" value={all_info_copy.last_name} variant="outlined"
                                    onChange={(e) => {
                                        handleFieldChange('last_name', e.target.value)
                                    }}
                                    InputLabelProps={{
                                        shrink: all_info_copy.last_name !== '', // Ensure label stays floated if there's a value
                                    }}
                                    disabled={!editingMode}
                                />

                                <TextField label="Email" value={userInfo.email} variant="outlined"
                                    InputLabelProps={{
                                        shrink: all_info_copy.email !== '', // Ensure label stays floated if there's a value
                                    }}
                                    disabled={true}
                                />

                                <TextField label="Country" value={userInfo.country_code} variant="outlined"
                                    InputLabelProps={{
                                        shrink: all_info_copy.country_code !== '', // Ensure label stays floated if there's a value
                                    }}
                                    disabled={true}
                                />


                                <FormControl variant="outlined" className="ps_user_info_water_unit_select">
                                    <InputLabel id="gender-label">Gender</InputLabel>
                                    <Select
                                        labelId="gender-label"
                                        value={userInfo.gender}
                                        onChange={null}
                                        label="Gender"
                                        disabled={!editingMode}
                                    >
                                        <MenuItem value={"1"}>Male</MenuItem>
                                        <MenuItem value={"0"}>Female</MenuItem>
                                    </Select>

                                </FormControl>

                                <TextField label="Height" value={Number(all_info_copy.height)} variant="outlined"

                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Allow only positive numbers or empty input (to clear field)
                                        if (!isNaN(value) && Number(value) >= 0) {
                                            handleFieldChange('height', e.target.value)
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: all_info_copy.height !== '', // Ensure label stays floated if there's a value
                                    }}
                                    disabled={!editingMode}
                                    type="number"
                                />


                                <TextField label="Weight" value={all_info_copy.weight} variant="outlined"
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Allow only positive numbers or empty input (to clear field)
                                        if (!isNaN(value) && Number(value) >= 0) {
                                            handleFieldChange('weight', e.target.value)
                                        }
                                    }}

                                    InputLabelProps={{
                                        shrink: all_info_copy.weight !== '', // Ensure label stays floated if there's a value
                                    }}
                                    disabled={!editingMode}
                                    type="number"
                                />

                                <FormControl variant="outlined" className="ps_user_info_water_unit_select">
                                    <InputLabel id="gender-label">Weight Unit</InputLabel>
                                    <Select
                                        labelId="gender-label"
                                        value={all_info_copy.weight_unit}
                                        onChange={(e) => { handleFieldChange('weight_unit', e.target.value) }}
                                        label="Weight Unit"
                                        disabled={!editingMode}
                                    >
                                        <MenuItem value={"kg"}>kg</MenuItem>
                                        <MenuItem value={"lbs"}>lbs</MenuItem>
                                    </Select>

                                </FormControl>
                            </div>
                        </div>

                        <div className="ps_user_info_personal_info" >
                            <p className="font_family_ovo font_size_24">
                                Preferences
                            </p>

                            <div className="ps_user_info_preferences_inner">
                                <p className="font_family_ovo font_size_20 ">
                                    Goals
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl component="fieldset">
                                        <FormGroup row>
                                            {
                                                all_info_copy.configs.filter((i) => i.id === 11)[0].options.map((c) => {
                                                    return <FormControlLabel
                                                        key={c.text}

                                                        control={

                                                            <Checkbox
                                                                checked={
                                                                    all_info_copy.planner_goal_fk.includes(c.id)
                                                                }
                                                                onChange={(e) => handleCheckboxChange('planner_goal_fk', c.id, e.target.checked)}
                                                                value={c.id}
                                                            />
                                                        }
                                                        label={c.text}
                                                        disabled={!editingMode}

                                                    />
                                                })

                                            }
                                        </FormGroup>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="ps_user_info_preferences_inner">
                                <p className="font_family_ovo font_size_20 ">
                                    Activity Level
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl component="fieldset">
                                        <FormGroup row>
                                            {
                                                all_info_copy.configs.filter((i) => i.id === 12)[0].options.map((c) => {
                                                    return <FormControlLabel
                                                        key={c.text}

                                                        control={

                                                            <Checkbox
                                                                checked={
                                                                    all_info_copy.activity_level == c.id
                                                                }
                                                                onChange={(e) => handleCheckboxChange('activity_level', c.id)}
                                                                value={c.id}
                                                            />
                                                        }
                                                        label={c.text}
                                                        disabled={!editingMode}

                                                    />
                                                })

                                            }
                                        </FormGroup>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="ps_user_info_preferences_inner" style={{ gap: '20px' }}>
                                <p className="font_family_ovo font_size_20">
                                    Water Tracker
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl variant="outlined" className="ps_user_info_water_unit_select">
                                        <InputLabel id="water-unit-label">Water Tracker Unit</InputLabel>
                                        <Select
                                            labelId="water-unit-label"
                                            value={all_info_copy.water_unit}
                                            onChange={(e) => {
                                                handleWaterUnitFieldChange(e.target.value)

                                            }}
                                            label="Water Tracker Unit"
                                            disabled={!editingMode}

                                        >
                                            {Object.entries(WaterTrackerUnits).map(([key, value]) => (
                                                <MenuItem key={key} value={value}>{key}</MenuItem>
                                            ))}

                                        </Select>

                                    </FormControl>

                                    <TextField
                                        label="Daily Water Goal"
                                        value={all_info_copy.daily_water_goal}
                                        variant="outlined"
                                        onChange={(e) => {
                                            const value = e.target.value;

                                            // Allow only positive numbers or empty input (to clear field)
                                            if (!isNaN(value) && Number(value) >= 0) {
                                                handleFieldChange('daily_water_goal', value);
                                            }
                                        }}
                                        InputLabelProps={{
                                            shrink: all_info_copy.daily_water_goal !== '', // Ensure label stays floated if there's a value
                                        }}
                                        disabled={!editingMode}
                                    />

                                </div>
                            </div>



                            <div className="ps_user_info_preferences_inner">
                                <p className="font_family_ovo font_size_20 ">
                                    Cuisines
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl component="fieldset">
                                        <FormGroup row>
                                            {
                                                all_info_copy.allCuisines.map((c) => {
                                                    return <FormControlLabel
                                                        key={c.name}
                                                        control={
                                                            <Checkbox
                                                                checked={
                                                                    all_info_copy.fav_cuisines.includes(c.cuisine_id)
                                                                }
                                                                onChange={(e) => handleCheckboxChange('fav_cuisines', c.cuisine_id, e.target.checked)}
                                                                value={c.cuisine_id}
                                                            />
                                                        }
                                                        label={c.name}
                                                        disabled={!editingMode}

                                                    />
                                                })

                                            }
                                        </FormGroup>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="ps_user_info_preferences_inner">
                                <p className="font_family_ovo font_size_20 ">
                                    Courses
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl component="fieldset">
                                        <FormGroup row>
                                            {
                                                all_info_copy.allCourses.map((c) => {
                                                    return <FormControlLabel
                                                        key={c.text}
                                                        control={
                                                            <Checkbox
                                                                checked={all_info_copy.courses.includes(c.id)}
                                                                onChange={(e) => handleCheckboxChange('courses', c.id, e.target.checked)}
                                                                value={c.id}
                                                            />
                                                        }
                                                        label={c.text}
                                                        disabled={!editingMode}
                                                    />
                                                })

                                            }
                                        </FormGroup>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="ps_user_info_preferences_inner">
                                <p className="font_family_ovo font_size_20 ">
                                    Dietary Restrictions
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl component="fieldset">
                                        <FormGroup row>
                                            {
                                                all_info_copy.configs.filter((i) => i.id === 10)[0].options.map((c) => {
                                                    return <FormControlLabel
                                                        key={c.text}
                                                        control={
                                                            <Checkbox
                                                                checked={
                                                                    all_info_copy.dietary_restrictions_fks.includes(c.id)
                                                                }
                                                                onChange={(e) => handleCheckboxChange('dietary_restrictions_fks', c.id, e.target.checked)}
                                                                value={c.id}
                                                            />
                                                        }
                                                        label={c.text}
                                                        disabled={!editingMode}

                                                    />
                                                })

                                            }
                                        </FormGroup>
                                    </FormControl>
                                </div>
                            </div>

                            <div className="ps_user_info_preferences_inner" style={{ gap: '20px' }}>
                                <p className="font_family_ovo font_size_20 ">
                                    Monthly Budget
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl variant="outlined" className="ps_user_preferences_prep_time">
                                        <InputLabel id="prep-time-label">Budget</InputLabel>
                                        <Select
                                            labelId="prep-time-label"
                                            value={all_info_copy.budget}
                                            onChange={(e) => {
                                                handleFieldChange('budget', e.target.value)
                                            }}
                                            label="Prep Time"
                                            disabled={!editingMode}
                                        >
                                            {
                                                // Use correct comparison and return in map
                                                configs.filter((i) => i.id === 5)[0].options.map((c) => (
                                                    <MenuItem key={c.id} value={c.id}>{c.text}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </div>

                            </div>

                            <div className="ps_user_info_preferences_inner" style={{ gap: '20px' }}>
                                <p className="font_family_ovo font_size_20 ">
                                    Max Meal Prep Time
                                </p>
                                <div className="ps_user_info_preferences_items">
                                    <FormControl variant="outlined" className="ps_user_preferences_prep_time">
                                        <InputLabel id="prep-time-label">Prep Time</InputLabel>
                                        <Select
                                            labelId="prep-time-label"
                                            value={all_info_copy.prep_time}
                                            onChange={(e) => {
                                                handleFieldChange('prep_time', e.target.value)
                                            }}
                                            label="Prep Time"
                                            disabled={!editingMode}
                                        >
                                            {
                                                // Use correct comparison and return in map
                                                configs.filter((i) => i.id === 14)[0].options.map((c) => (
                                                    <MenuItem key={c.id} value={c.id}>{c.text}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </div>

                            </div>
                        </div>
                    </div>

                </div >
            }
            <br />
            <br />

        </div>


    );
}


export default ProfileAndSettings;